module.exports = __webpack_public_path__ + "static/img/organization-banner@2x.e12d895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/organization-banner@2x.png
// module id = 932
// module chunks = 0